import React from "react";

const Kba = window.dreamchimney.kba;

const KbaRender = ({ margin = "60px auto" }) => (
  <div style={{ display: "block", textAlign: "center", margin }}>
    <Kba destination="promos" />
    <div style={{ color: "#ccc" }}>A d v e r t i s e m e n t</div>
  </div>
);

export default React.memo(KbaRender);
